//---------------------------------------------------------------------------
// プラムページ　審査結果一覧リスト
//---------------------------------------------------------------------------
var PlumContractResultList = Backbone.View.extend({
	events:{
		"click #search_form .panel-action-toggle" : "onClickSearchToggle",
		"click #contract_result_regist" : "onClickContractResultRegist",
		"click .edit_btn" : "onClickEditBtn",
		"click .contract_result_regist" : "onClickContractResultEdit",
		"shown.bs.modal #contract_result_edit" : "onShownContractResultEdit",
		"hidden.bs.modal #contract_result_edit" : "onHiddenContractResultEdit",
		"click #type1" : "onClickType1",
		"click #type2" : "onClickType2",
		"click #get_store_btn" : "onClickGetStore",
		"click #registContractResultBtn" : "onRegistContractResultBtn",
		
	},



	initialize:function(){

		var search_toggle = Cookies.get('plum_contract_result_search_toggle');
		if(!search_toggle){
			this.$("#search_form").removeClass("panel-collapsed");
		}
	},


/*=============================
=            Event            =
=============================*/

	onClickContractResultRegist:function(e){
		this.$('#type1').click();
		var today = moment();
		this.$('.regist-year').val(today.year());
		this.$('.regist-month').val(today.month()+1);
		this.$('.regist-day').val(today.date());
		this.$('#contract_result_edit').modal('show');
		this.$('#frr_big_id').val('');
		this.$('#type_tr').show();
		//this.$('#frr_int_number').prop('readonly',false);
		this.$('#frr_int_number').prop('readonly',true);
		this.$('#store_name').prop('readonly',true);

		// this.ajax(__RESULT_GET_NUMBER,{},function(res){
		// 	this.$('#frr_int_number').val(res.number);
		// },function(){

		// });
	},

	onClickEditBtn:function(e){
		var self = $(e.currentTarget);
		var json = self.data('json');

		console.log(json);

		this.$('#frr_big_id').val(json.frr_big_id);
		this.$('#type_tr').hide();
		this.$('#frr_int_number').prop('readonly',true);

		this.$('#store_name').prop('readonly',false);

		this.$('#frr_int_number').val(json.frr_int_number);

		var reception = moment(json.frr_dt_reception_at);
		this.$('.regist-year').val(reception.year());
		this.$('.regist-month').val(reception.month()+1);
		this.$('.regist-day').val(reception.date());

		this.$('#get_store_id').val(json.frr_var_store_number);
		this.$('#frr_big_store_id').val(json.frr_big_store_id);
		this.$('#frr_big_branch_id').val(json.frr_big_branch_id);
		this.$('#store_name').val(json.frr_var_store_name);

		if(json.frr_is_include){
			this.$('.show_type2').show();
		}else{
			this.$('.show_type2').hide();
		}

		this.$('input[name="frr_var_card_number"]').val(json.frr_var_card_number);
		this.$('input[name="frr_int_reception_number"]').val(json.frr_int_reception_number);
		this.$('input[name="frr_var_approval_number"]').val(json.frr_var_approval_number);
		this.$('input[name="frr_var_name"]').val(json.frr_var_name);
		this.$('input[name="frr_int_credit_line"]').val(json.frr_int_credit_line);
		this.$('input[name="frr_int_apply_amount"]').val(json.frr_int_apply_amount);
		this.$('textarea[name="frr_txt_note"]').text(json.frr_txt_note);

		if(json.frr_var_possibility === '可'){this.$('#result1').prop('checked',true);}
		if(json.frr_var_possibility === '否'){this.$('#result2').prop('checked',true);}
		if(json.frr_var_possibility === '保留'){this.$('#result3').prop('checked',true);}

		if(json.frr_var_account.indexOf("◯") !== -1){this.$('#kouza1').prop('checked',true);}
		if(json.frr_var_account.indexOf("△") !== -1){this.$('#kouza2').prop('checked',true);}
		if(json.frr_var_account.indexOf("✕") !== -1){this.$('#kouza3').prop('checked',true);}

		if(json.frr_var_apply === '同時申込'){this.$('#apply1').prop('checked',true);}
		if(json.frr_var_apply === '売上のみ'){this.$('#apply2').prop('checked',true);}
		if(json.frr_var_apply === '入会のみ'){this.$('#apply3').prop('checked',true);}

		this.$('#contract_result_edit').modal('show');
	},

	onClickContractResultEdit:function(e){
		this.$('#contract_result_edit').modal('show');
	},

	onShownContractResultEdit:function(e){
		console.log('aaaaaaa');
	},

	onClickType1:function(e){
		this.$('.show_type1').show();
		this.$('.show_type2').hide();
		this.$('.show_type2 input').val('');
		this.$('.show_type2 [type="radio"]').prop('checked',false);

		this.$('#contract_result_edit .modal-content .form_td.frr_int_number').waitMe({effect : 'progressBar'});
		this.ajax(__RESULT_GET_NUMBER,{},function(res){
			this.$('#frr_int_number').val(res.number);
			this.$('#contract_result_edit .modal-content .form_td.frr_int_number').waitMe('hide');
		},function(){

		});
	},

	onClickType2:function(e){
		this.$('.show_type1 input').val('');
		this.$('.show_type1').hide();
		this.$('.show_type2').show();

		this.$('#contract_result_edit .modal-content .form_td.frr_int_number').waitMe({effect : 'progressBar'});
		this.ajax(__RESULT_GET_NUMBER,{include:true},function(res){
			this.$('#frr_int_number').val(res.number);
			this.$('#contract_result_edit .modal-content .form_td.frr_int_number').waitMe('hide');
		},function(){

		});
	},

	onClickGetStore:function(e){
		e.preventDefault();

		this.$('#frr_big_store_id').val('');
		this.$('#frr_big_branch_id').val('');
		this.$('#store_name').val('');
		this.$('#store_error_message').text('');
		this.$('.frr_big_store_id.form_td .post_error').remove();

		this.$('#contract_result_edit .modal-content .form_td.frr_big_store_id').waitMe({effect : 'progressBar'});

		this.ajax(__RESULT_GET_STORE,{
			code:this.$('#get_store_id').val()
		},function(res){
			console.log(typeof res);
			if(_.isArray(res)){
				this.$('#store_error_message').text('データが取得できませんでした。');
			}else{
				this.$('#store_error_message').text('');

				this.$('#store_name').val(res.store_name + ' - ' + res.branch_name);
				this.$('#frr_big_store_id').val(res.store_id);
				this.$('#frr_big_branch_id').val(res.branch_id);
				this.$('#store_name').prop('readonly',false);
			}
			this.$('#contract_result_edit .modal-content .form_td.frr_big_store_id').waitMe('hide');
			//if(typeof res === "Object")
		},function(){
			this.$('#store_error_message').text('データが取得できませんでした。');
			this.$('#contract_result_edit .modal-content .form_td.frr_big_store_id').waitMe('hide');
		});
	},

	onHiddenContractResultEdit:function(){
		this.$('#frr_int_number').val('');
		this.$('.regist-year').val("");
		this.$('.regist-month').val("");
		this.$('.regist-day').val("");
		this.$('#frr_big_store_id').val('');
		this.$('#frr_big_branch_id').val('');
		this.$('#store_name').val('');
		this.$('#store_error_message').text('');
		this.$('#get_store_id').val('');

		this.$('input[name="frr_var_card_number"]').val('');
		this.$('input[name="frr_int_reception_number"]').val('');
		this.$('input[name="frr_var_approval_number"]').val('');
		this.$('input[name="frr_var_name"]').val('');
		this.$('input[name="frr_int_credit_line"]').val('');
		this.$('input[name="frr_int_apply_amount"]').val('');
		this.$('textarea[name="frr_txt_note"]').val('');
		this.$('input[name="frr_var_possibility"]').prop('checked',false);
		this.$('input[name="frr_var_account"]').prop('checked',false);
		this.$('input[name="frr_var_apply"]').prop('checked',false);

		this.$('.form_td .post_error').remove();
	},

	onRegistContractResultBtn:function(e){
		e.preventDefault();
		this.$('#contract_result_edit .modal-content').waitMe({effect : 'progressBar'});
		var data = _.reduce(this.$('#contract_result_form').serializeArray(),function(r,c){
			r[c.name] = c.value;
			return r;
		},{});

		var account = '';
		if(this.$('#kouza1').prop('checked')){account += '◯';}
		if(this.$('#kouza2').prop('checked')){account += '△';}
		if(this.$('#kouza3').prop('checked')){account += '✕';}

		data.frr_var_account = account;

		var apply = '';
		if(this.$('#apply1').prop('checked')){apply = '同時申込';}
		if(this.$('#apply2').prop('checked')){apply = '売上のみ';}
		if(this.$('#apply3').prop('checked')){apply = '入会のみ';}

		data.frr_var_apply = apply;

		// var type = '';
		// if(this.$('#type1').prop('checked')){type = '0';}
		// if(this.$('#type2').prop('checked')){type = '1';}

		// data.frr_is_include = type;

		

		this.$('.form_td .post_error').remove();

		this.ajax(__RESULT_POST,data,function(res){
			//console.log(res);
			this.$('#contract_result_edit .modal-content').waitMe('hide');
			this.$('#contract_result_edit').modal('hide');
			setTimeout(function(){
				window.location.href = __RESULT_POST;
			},500)
		},function(error){
			var errors = error.responseJSON;
			for (var key in errors) {
				if (Object.hasOwnProperty.call(errors, key)) {
					var element = errors[key];
					this.$('.form_td.'+key).append("<p class='post_error' style='font-weight:bold;color:red; margin-top:5px;margin-bottom:0;'>"+element[0]+"</p>");
				}
			}
			this.$('#contract_result_edit .modal-content').waitMe('hide');
		});
	},

	onClickSearchToggle:function(){
		var self = this;
		setTimeout(function(){
			var col = self.$("#search_form").hasClass("panel-collapsed");
			if(col){
				Cookies.set('plum_contract_result_search_toggle', 1);
			}else{
				Cookies.remove('plum_contract_result_search_toggle');
			}
		},1000);
	},

	onShowModal:function(e){
		
	},
	

/*=====  End of Event  ======*/



});